<template>
    <div class="shaded m-4">
        <div v-if="getClonedAgent">
            <div class="tab-panel padded">
                <agent-commissions @cancel="cancel" @save="save" @back="back" :showButtons="showButtons" :showExistingAgentSelector="showExistingAgentSelector" :selectedAgent="passedForm"></agent-commissions>
            </div>
        </div>
        <div v-else>
            <div class="shaded m-4">
                <div class="form-group row">
                    <div class="col-sm-12">
                        <div class="panel shaded">
                            <agent-commissions @cancel="cancel" @save="save"></agent-commissions>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import AgentCommissions from './AgentCommissions'

    export default {
        props: {
            currentStep: Number,
            showButtons: {
                default: true
            },
            passedForm: {
                default: null
            },
            showExistingAgentSelector: {
                default: false
            }
        },
        computed: {
            ...mapGetters([
                'getClonedAgent',
            ]),
        },
        methods: {
            ...mapActions([
                'updateAgent',
                'addAgent',
                'clearClonedAgent'
            ]),
            cancel: function() {
                this.$emit('cancelling');
            },
            back: function() {
                this.$emit('goToPrevious', { form: this.getClonedAgent });
            },
            save: function() {

                if(this.getClonedAgent && this.getClonedAgent.id) {
                    this.updateAgent({
                        agent: this.getClonedAgent,
                        sendInvite: true
                    });
                } else {
                    this.addAgent();
                }

                this.clearClonedAgent()
            }
        },
        components: {
            AgentCommissions,
        }
    }
</script>



// WEBPACK FOOTER //
// AgentCommissionsWrapper.vue?515e049a